import request from '../utils/request'
import type { ApiResult, PageResult } from '../utils/request'
import type { NoticeMessage, NoticeStatus } from '../types/notice'

export function getNoticeUnreadCount() {
  return request.get<any, ApiResult<number>>('/notices/unread-count', { silentError: true })
}

export function getNoticeList(params: {
  pageNum?: number
  pageSize?: number
  status?: NoticeStatus | 'all'
  domain?: string
  keyword?: string
}) {
  return request.get<any, ApiResult<PageResult<NoticeMessage>>>('/notices', {
    params,
    silentError: true
  })
}

export function markNoticeRead(id: string | number) {
  return request.put<any, ApiResult<boolean>>(`/notices/${id}/read`, {}, { silentError: true })
}

export function markAllNoticesRead() {
  return request.put<any, ApiResult<boolean>>('/notices/read-all', {}, { silentError: true })
}

export function markNoticeHandled(id: string | number) {
  return request.put<any, ApiResult<boolean>>(`/notices/${id}/handled`, {}, { silentError: true })
}
